<h6 class="m-0 py-3 pl-4 uppercase incada-titlebar">Incada {{resourceType}} Details</h6>
<div *ngIf="isParentOrg" class="grid gap-2 py-4 px-8">
  <div class="grid grid-cols-[300px_300px] gap-4 font-bold">
    <span>Incada Tenant Name</span>
    <span>Incada Tenant Slug</span>
  </div>
  <div class="grid grid-cols-[300px_300px] gap-4">
    <span>{{organization?.incadaName || 'N/A'}}</span>
    <span>{{organization?.incadaSlug || 'N/A'}}</span>
  </div>
</div>
<div *ngIf="!isParentOrg" class="grid gap-2 py-4 px-8">
  <div class="grid grid-cols-[300px_300px] gap-4 font-bold">
    <span>Incada Site Name</span>
    <span>Incada Organization Unit Name</span>
  </div>
  <div class="grid grid-cols-[300px_300px] gap-4">
    <span>{{organization?.incadaName || 'N/A'}}</span>
    <span>{{organization?.incadaOrgUnitName || 'N/A'}}</span>
  </div>
</div>
<div *ngIf="isParentOrg && sites.length" class="flex flex-col">
  <h6 class="m-0 py-3 pl-4 uppercase incada-titlebar">Sites</h6>
  <div class="grid gap-2 py-4 px-8">
    <div class="grid grid-cols-[300px_300px_220px] gap-4 font-bold">
      <span>Name</span>
      <span>Incada Site Name</span>
      <span>Incada Org Unit Name</span>
    </div>
    <div *ngFor="let site of sites" class="grid grid-cols-[300px_300px_220px] gap-4">
      <span>{{site.name}}</span>
      <span>{{site.incadaName || 'N/A'}}</span>
      <span>{{site.incadaOrgUnitName || 'N/A'}}</span>
    </div>
  </div>
</div>